export default 'M8 10V7a4 4 0 0 1 8 0v3zm11 .02V7A7 7 0 0 0 5 7v3.02a8.75 8.75 0 1 0 14 0';